import { useId } from 'react';

// Exact vector exported from Figma 170:419; ids are isolated for multiple drawers.
export function CartBenefitsGradient() {
  const filterId = useId();
  const gradientId = useId();
  return (
    <div aria-hidden className="pointer-events-none absolute inset-[-13.16%_-3.7%_24.79%_-59.15%]">
      <div className="absolute inset-[-91.55%_-13.48%]">
        <svg
          preserveAspectRatio="none"
          overflow="visible"
          style={{ display: 'block' }}
          width="100%"
          height="100%"
          viewBox="0 0 678.145 222.643"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g filter={`url(#${filterId})`}>
              <path
                d="M289.931 103.402C263.723 86.4339 401.033 73.5609 430.946 72L72 72L72 150.643L606.145 150.643C439.492 144.169 316.14 120.37 289.931 103.402Z"
                fill={`url(#${gradientId})`}
              />
            </g>
          </g>
          <defs>
            <filter
              id={filterId}
              x="-2.623e-06"
              y="0"
              width="678.145"
              height="222.643"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="36" result="effect1_foregroundBlur_0_13" />
            </filter>
            <linearGradient
              id={gradientId}
              x1="425.248"
              y1="111.321"
              x2="117.88"
              y2="111.321"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#311275" />
              <stop offset="1" stopColor="#3D1690" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  );
}
